import {apiMiddleware} from "./api";
import {apiConfigureMiddleware} from "./apiConfigure";
import {apiLoadingMiddleware} from "./apiLoading.middleware";

export const coreMiddleware = [
    apiConfigureMiddleware,
    apiMiddleware,
    apiLoadingMiddleware
];